import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-sts-section-header-side',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>`
})
export class StsSectionHeaderSideComponent implements OnInit {

  @ViewChild(TemplateRef) template: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }

}
